import React from 'react';

interface Tab {
  label: string;
}

interface TabListProps {
  tabs: Tab[];
  activeTab: number;
  onTabClick: (index: number) => void;
}

const TabList: React.FC<TabListProps> = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div>
      <div className="flex border-b border-gray-200">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`py-2 px-4 text-sm font-medium transition-colors rounded-sm duration-300 ${
              activeTab === index
                ? 'bg-blue-500 text-white'
                : 'bg-transparent text-gray-500 hover:bg-gray-200'
            }`}
            onClick={() => onTabClick(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="relative"></div>
    </div>
  );
};

export default TabList;
